export default __webpack_public_path__ + "assets/fonts/c12c26dd6d74b8c1182bbe69d00ac5e4.woff";